import { ApiResponse } from '../../../../constants/types';
import {
  StudentProfile,
  PutStudentBasicInfoRequest,
  PutStudentGuardianInfoRequest,
} from '../../../../constants/types/student/profile/type';
import instance from '../../../axios/utils.ts/instance';

//============================== 학생 정보 조회 ==============================
/**
 * 학생 본인 정보 조회
 * @returns
 */
export const getStudentProfile = async () => {
  const response =
    await instance.get<ApiResponse<StudentProfile>>('/v1/user/student');
  return response.data.data;
};

//============================== 기본 정보 관리 ==============================
/**
 * 학생 본인 기본 정보 수정
 * @description 이름은 수정할 수 없지만 요청 형식을 유지하기 위해 조회한 값을 그대로 함께 보낸다.
 * @param name 조회한 이름 (변경하지 않는다)
 * @param form 기본 정보 영역의 폼 값
 */
export const putStudentBasicInfo = async (
  request: PutStudentBasicInfoRequest,
) => {
  const result = await instance.put<ApiResponse<StudentProfile>>(
    '/v1/user/student/basic-info',
    request,
  );
  return result.data.data;
};

//============================== 보호자 정보 관리 ==============================
/**
 *
 * @description 학생 보호자(법정대리인) 정보를 수정합니다.
 * - 요청: guardianInfo는 객체 1개입니다 (배열 아님 - 배열 전송 시 400). 예: { "guardianInfo": { "name": "보호자", "phone": "01012341234", "gender": "FEMALE", "birthday": "1997-01-03" } }
 * - 처리: 처리: 저장 시 교사/어드민 화면의 보호자 목록(parents)에도 같은 내용이 동기화됩니다 (같은 성별 유형 행 갱신/추가).
 * @param classId 클래스 코드
 */
export const putStudentGuardianInfo = async (
  guardianInfo: PutStudentGuardianInfoRequest,
) => {
  const result = await instance.put<ApiResponse<StudentProfile>>(
    '/v1/user/student/parent-info',
    { guardianInfo },
  );
  return result.data.data;
};

//============================== 클래스 코드 관리 ==============================
/**
 * 학생 본인 클래스 코드 추가
 * @description 응답으로 갱신된 내 정보(클래스 목록 포함)를 돌려준다.
 * @param classId 클래스 코드
 */
export const putStudentClassCode = async (classId: string) => {
  const result = await instance.put<ApiResponse<StudentProfile>>(
    '/v1/user/student/class-code',
    { classIds: [classId] },
  );
  return result.data.data;
};

/**
 * 학생 본인 클래스 코드 삭제
 * @description 응답으로 갱신된 내 정보(클래스 목록 포함)를 돌려준다.
 * @param classId 클래스 코드
 */
export const deleteStudentClassCode = async (classId: string) => {
  const result = await instance.delete<ApiResponse<StudentProfile>>(
    `/v1/user/student/class-code/${classId}`,
  );
  return result.data.data;
};
